import { genericApi } from '~/api'
import { useQuery } from '@tanstack/react-query'

export const useCourseQuery = (token) =>
  useQuery({
    queryKey: ['courses', token],
    queryFn: async () => {
      const { data } = await genericApi.getCourse(token)
      return data
    }
  })

export const useCountryQuery = () =>
  useQuery({
    queryKey: ['countries'],
    queryFn: async () => {
      const { data } = await genericApi.getCountry()
      return data.data
    }
  })
